import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import imgWax1 from '../components/Wax11.jpg';
import imgWax2 from '../components/Wax22.jpg';
import imgWax3 from '../components/Cofret.jpg';

const WaxMeltsSection = () => {
  const [selectedProducts, setSelectedProducts] = useState({});

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const scents = ['Sleep In The Clouds', 'Luxurious Vanilla', 'Spicy Raspberry', 'Floral Symphony', 'Tropical Island'];

  const waxMelts = [
    {
      id: 1,
      name: 'Wax Melt Amostra',
      image: imgWax2,
      description: '2 unidades de uma fragrância à sua escolha',
      price: '1.99 €',
      scents: ['Sleep In The Clouds', 'Luxurious Vanilla', 'Spicy Raspberry', 'Floral Symphony', 'Tropical Island', 'Watermelon Gummy', 'Coffee Break']
    },
    {
      id: 2,
      name: 'Wax Melt',
      image: imgWax1,
      description: '10 unidades de uma fragrância à sua escolha',
      price: '5.00 €',
      scents: ['Sleep In The Clouds', 'Luxurious Vanilla', 'Spicy Raspberry', 'Floral Symphony', 'Tropical Island', 'Watermelon Gummy', 'Coffee Break']
    },
    {
      id: 3,
      name: 'Coffret Wax Melt',
      image: imgWax3,
      description: 'Queimador de cera com 10 unidades de wax melt, uma vela de chá e a sua recarga',
      price: '17.00 €',
      scents: ['Sleep In The Clouds', 'Luxurious Vanilla', 'Spicy Raspberry', 'Floral Symphony', 'Tropical Island', 'Watermelon Gummy', 'Coffee Break']
    }
  ];

  const handleScentSelection = (productId, scent) => {
    setSelectedProducts(prev => ({
      ...prev,
      [productId]: scent
    }));
  };

  return (
    <div className="min-h-screen bg-pure_fundo">
      <Header />
      
      {/* Hero Section */}
      <section className="relative py-24 overflow-hidden">
        <div className="absolute inset-0 bg-pure_fundo"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-lora text-pure_titulo mb-6">
            Wax Melts
          </h1>
          <p className="text-xl max-w-3xl mx-auto leading-relaxed font-montserrat text-pure_btn1_txt">
            Cada wax melt é uma explosão de fragrância capaz de transformar o teu espaço em minutos
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12">
            {waxMelts.map((product) => (
              <div key={product.id} className="group">
                <div className="bg-white rounded-3xl shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105 overflow-hidden">
                  {/* Product Image */}
                  {/*
                  <div className="aspect-w-16 aspect-h-12 relative overflow-hidden">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  </div>
                   */}

                  {/* Product Image */}
                  <div className="aspect-w-16 aspect-h-12 relative overflow-hidden">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-110 object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  </div>
                  
                  {/* Product Details */}
                  <div className="p-8">
                    <h3 className="text-2xl font-bold font-lora text-pure_titulo mb-3">
                      {product.name}
                    </h3>
                    <p className="leading-relaxed font-montserrat text-pure_btn1_txt mb-6">
                      {product.description}
                    </p>
                    
                    {/* Price */}
                    <div className="text-xl font-bold font-lora text-pure_titulo mb-6">
                      {product.price}
                    </div>
                    
                    {/* Scent Selection */}
                    <div className="mb-6">
                      <h4 className="text-sm font-semibold font-montserrat text-pure_btn1_txt mb-3">
                        Opções disponíveis:
                      </h4>
                      <div className="grid grid-cols-2 gap-2">
                        {product.scents.map((scent) => (
                          <button
                            key={scent}
                            onClick={() => handleScentSelection(product.id, scent)}
                            className={`p-2 rounded-lg text-sm transition-all duration-300 ${
                              selectedProducts[product.id] === scent
                                ? 'bg-pure_btn1 text-pure_btn1_txt font-montserrat'
                                : 'bg-pure_btn1 text-pure_btn1_txt font-montserrat'
                            }`}
                          >
                            {scent}
                          </button>
                        ))}
                      </div>
                    </div>
                    
                    {/* Instagram CTA */}
                    <div className="space-y-3">
                      <a
                        href="https://instagram.com/pure.pt_"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-full bg-pure_gray bg-opacity-20 font-montserrat text-pure_btn1_txt py-3 px-6 rounded-full font-semibold transition-all duration-300 hover:scale-105 shadow-lg flex items-center justify-center space-x-2"
                     
                      >
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                        </svg>
                        <span>Encomenda no Instagram</span>
                      </a>
                      
                      {/* 
                      {selectedProducts[product.id] && (
                        <div className="text-center text-[#A0522D] text-sm">
                          Selected: {selectedProducts[product.id]}
                        </div>
                      )}
                      */}

                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Use Section */}
      <section className="py-16 bg-white bg-opacity-60 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-lora text-pure_titulo mb-4">
              Como Deves Usar os Teus Wax Melts
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Step 1 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-pure_btn1 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-pure_titulo" style={{ fontFamily: 'Dream Avenue, serif' }}>1</span>
              </div>
              <h3 className="text-xl font-lora text-pure_titulo mb-2">
                Colocar no queimador
              </h3>
              <p className="text-base font-montserrat text-pure_btn1_txt">
                Coloca 1 a 2 wax melts no queimador
              </p>
            </div>

            {/* Step 2 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-pure_btn1 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-pure_titulo" style={{ fontFamily: 'Dream Avenue, serif' }}>2</span>
              </div>
              <h3 className="text-xl font-lora text-pure_titulo mb-2">
                Acende
              </h3>
              <p className="text-base font-montserrat text-pure_btn1_txt">
                Acende o teu queimador com uma vela de chá, e deixa a fragrância preencher o espaço
              </p>
            </div>

            {/* Step 3 */}
            <div className="text-center">
              <div className="w-16 h-16 bg-pure_btn1 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-pure_titulo" style={{ fontFamily: 'Dream Avenue, serif' }}>3</span>
              </div>
              <h3 className="text-xl font-lora text-pure_titulo mb-2">
                Substitui quando precisares
              </h3>
              <p className="text-base font-montserrat text-pure_btn1_txt">
                Pode ser derretido 3 a 4 vezes. Quando a fragrância acabar, limpa o queimador e coloca um novo wax melt 
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      {/*
      <section className="py-24 bg-white bg-opacity-60 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-[#8B4513] mb-6" style={{ fontFamily: 'Dream Avenue, serif' }}>
              Why Choose Our Wax Melts?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            //Benefit 1
            <div className="text-center group">
              <div className="w-20 h-20 bg-[#8B4513] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#A0522D] transition-colors duration-300">
                <svg className="w-10 h-10 text-[#f5e1ce]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" style={{ fontFamily: 'The Seasons, serif' }}>
                Long-Lasting Scent
              </h3>
              <p className="text-[#A0522D] leading-relaxed" style={{ fontFamily: 'The Seasons, serif' }}>
                Our wax melts provide hours of consistent fragrance, giving you excellent value for your investment.
              </p>
            </div>

            //Benefit 2
            <div className="text-center group">
              <div className="w-20 h-20 bg-[#8B4513] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#A0522D] transition-colors duration-300">
                <svg className="w-10 h-10 text-[#f5e1ce]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" style={{ fontFamily: 'The Seasons, serif' }}>
                Safe & Clean
              </h3>
              <p className="text-[#A0522D] leading-relaxed" style={{ fontFamily: 'The Seasons, serif' }}>
                Flameless fragrance solution that's safe for families with children and pets. No open flames needed.
              </p>
            </div>

            //Benefit 3
            <div className="text-center group">
              <div className="w-20 h-20 bg-[#8B4513] rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-[#A0522D] transition-colors duration-300">
                <svg className="w-10 h-10 text-[#f5e1ce]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-[#8B4513] mb-4" style={{ fontFamily: 'The Seasons, serif' }}>
                Handcrafted Quality
              </h3>
              <p className="text-[#A0522D] leading-relaxed" style={{ fontFamily: 'The Seasons, serif' }}>
                Each wax melt is individually crafted with premium ingredients for consistent quality and performance.
              </p>
            </div>
          </div>
        </div>
      </section>
      */}

      {/* Instagram CTA */}
      <section className="py-24 bg-pure_gray bg-opacity-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-lora text-pure_titulo mb-6">
            Queres mais conforto e aconchego no teu espaço?
          </h2>
          <p className="text-xl font-montserrat text-pure_btn1_txt mb-8">
            Visita o nosso Instagram para encomendares e veres os nossos últimos lançamentos
          </p>
          <a
            href="https://instagram.com/pure.pt_"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-3 bg-pure_btn1 text-pure_btn1_txt font-montserrat py-4 px-8 rounded-full text-lg"
          >
            <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            <span>Visita a Pure</span>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WaxMeltsSection;